module.exports = __webpack_public_path__ + "img/reverse_eaxmple.e50c690f.png";